import { CLEAR_TOAST, SHOW_TOAST } from "./constant";

export const showToast = (message, type = "success", isAnimate = false) =>
    (dispatch) => {
        dispatch({
            type: SHOW_TOAST,
            payload: { message, type, isAnimate }
        });

        // Auto clear after trigger
        setTimeout(() => {
            dispatch({ type: CLEAR_TOAST });
        }, 3000);
    };